// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c4d3d8ed","264":"c4d3fd8b","311":"a3fab7df","340":"a633f360","393":"5d636086","488":"fd3863f6","586":"8400d69a","627":"652a6afa","765":"c3eaa5c6","789":"5a38dcc2","801":"809e6ba0"}[chunkId] + ".chunk.js";
};